import * as yup from 'yup';
import {
  Appointments,
  CustomerFiles,
  Customers,
  Employees,
  Services,
  Users,
} from '@prisma/client';
import { MAX_FILE_SIZE } from '../../constants/global';
import { isValidFileType } from '../../utils/global/helper';
import { ACCEPTED_FILE_TYPES } from '../../constants/customers';

export type CustomerOverview = Customers & {
  user: Users;
  appointments: (Appointments & {
    service: Services | null;
    employees: Employees & {
      user: Users;
    };
  })[];
  internalNotes: string | null;
  files: Pick<CustomerFiles, 'id' | 'url' | 'type' | 'name'>[];
};

export const customerFileSchema = yup.object({
  file: yup
    .mixed<File>()
    .test({
      name: 'file-type',
      message: 'Please provide a supported file type',
      test: (file: any, context) => {
        const isValid =
          !!file &&
          file instanceof File &&
          isValidFileType(file, ACCEPTED_FILE_TYPES);
        if (!isValid) context?.createError();
        return isValid;
      },
    })
    .test({
      name: 'file-size',
      message: `File too big, can't exceed ${MAX_FILE_SIZE / 1024 / 1024}MB`,
      test: (file: any, context) => {
        const isValid = file instanceof File && file?.size < MAX_FILE_SIZE;
        if (!isValid) context?.createError();
        return isValid;
      },
    }),
});

export type CustomerFileForm = yup.InferType<typeof customerFileSchema>;
